import React from 'react'
import ffffff from '../image/ffffff.avif'
import { styled } from '@mui/system';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
const useStyles = styled((theme) => ({
  root: {
    width: '100%',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '33.33%',
    flexShrink: 0,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
}));

function IOT_FAQ_page() {
  return (
    <div>
      <div className="mt-5">
        <div className="container pt-3">
          <div className="text-center Curriculum_Main_text">
            <div className="">
              <h2 className="display-6">Frequently Asked Questions</h2>
              <p className="pt-2">
                Our Responses to Your Inquiries: Unblocking the Way to Clarity
              </p>
            </div>
          </div>
          <div className="row">
            <div className="col-md-5">
              <div className="FAQ_img">
                <img
                  src={ffffff}
                  onContextMenu={(e) => e.preventDefault()}
                ></img>
              </div>
            </div>
            <div className="col-md-7 pt-5 d-none d-md-block">
              <div className="pt-5">
                <div className="pt-5">
                  <div className="pt-5">
                    <IOT_FAQ/>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-12 d-sm-block d-md-none mb-5">
              <IOT_FAQ/>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

function IOT_FAQ(){
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <div>
    <div className={classes.root}>
      <Accordion className='py-2' expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1bh-content"
          id="panel1bh-header" className='FAQ_background_color'
        >
          <Typography style={{fontSize:"1.2rem"}}>How does IoT work?</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          IoT devices collect data from their environment using sensors, process that data locally or in the cloud, and then take actions based on the processed data. Communication between devices and systems typically occurs through wired or wireless networks.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel2'} onChange={handleChange('panel2')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2bh-content"
          id="panel2bh-header"
          className='FAQ_background_color'
        >
          <Typography style={{fontSize:"1.2rem"}}>What are the benefits of IoT?</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          IoT offers numerous benefits, including increased efficiency, automation of tasks, improved decision-making through data analytics, enhanced convenience and comfort, and the ability to monitor and control systems remotely.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel3'} onChange={handleChange('panel3')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel3bh-content"
          id="panel3bh-header"
          className='FAQ_background_color'
        >
          <Typography style={{fontSize:"1.2rem"}}>How does IoT impact privacy?</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          IoT devices collect vast amounts of data about users and their environments, raising concerns about privacy and data protection. Organizations must implement appropriate measures, such as data anonymization and consent mechanisms, to safeguard user privacy.
          </Typography>
        </AccordionDetails>
      </Accordion>
    </div>
    </div>
  );
}
export default IOT_FAQ_page
